/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://u5erbirp2fejvil5xv4ajqbsa4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-u3ziqkuqrzhepb252kixufs36m",
    "aws_cognito_identity_pool_id": "us-east-1:aa072c8c-1f65-4ccf-a087-3ccf4d6ca12a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_4GbmUcuCy",
    "aws_user_pools_web_client_id": "75pe9m63aatfu1ki0nmalqvh13",
    "oauth": {}
};


export default awsmobile;
